export const uploadQuizReport = (payload?: any) => ({
    type: "@saga/UPLOAD_QUIZ_REPORT",
    payload
});

